<script>

  const date = new Date();
  const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
  const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
  export default {
    name: "web_trial_mould_order_index",
    data() {
      return {
        conditions: {
          begin: begin,
          end: end
        },
        columns: [
          {
            label: 'shimodanhao',
            prop: 'no',
            width: 120
          },
          {
            label: 'mujubianhao',
            prop: 'mould.no',
          },
          {
            label: 'mujubianma',
            prop: 'mould.code',
          },
          {
            label: 'mujumingcheng',
            prop: 'mould.name',
          }, {
            label: 'chanpinbianma',
            prop: 'material.code',
          }, {
            label: 'chanpinmingcheng',
            prop: 'material.name',
          }, {
            label: 'shimoshuliang',
            prop: 'trialMouldNum',
          }, {
            label: 'shimozhuangtai',
            prop: 'status',
            type: 'tag',
            tags: {
              1: {
                color: '#E6A23C',
                text: this.$t('daishenhe')
              },
              2: {
                color: '#67C23A',
                text: this.$t('yishenhe')
              },
              3: {
                color: '#F56C6C',
                text: this.$t('yifafang')
              }
            }
          }, {
            label: 'shimojielun',
            prop: 'conclusion',
            type: 'dictionary_tag',
            key: 'TRIAL_MOULD_CONCLUSION',
          }, {
            label: 'beizhu',
            prop: 'remark',
          }, {
            label: 'chuangjianshijian',
            prop: 'createTime',
            type: 'time',
          }, {
            label: 'chuangjianren',
            prop: 'createByObject.nickname',
          }, {
            label: 'shenheshijian',
            prop: 'checkTime',
            type: 'time',
          }, {
            label: 'shenheren',
            prop: 'checkUser.nickname',
          }, {
            label: 'fafangshijian',
            prop: 'issueTime',
            type: 'time',
          }, {
            label: 'fafangren',
            prop: 'issueUser.nickname',
          }, {
            label: 'jihuadanhao',
            prop: 'plan.no',
          }, {
            label: 'caozuo',
            type: 'slot',
            fixed: 'right',
            width: '250'
          }
        ],
        saveFormData: {},
        issuedFormData: {},
        options:[
          {value:1,label:'待审核'},
          {value:2,label:'已审核'},
          {value:3,label:'已发放'},
        ]
      }
    }, methods: {
      searchBtn() {
        this.yt.get(1);
      },
      clear() {
        this.yt.isShowEditDialog = false
        this.saveFormData = {},
            this.issuedFormData = {}
      },
      create() {
        this.http.post("web/trial/mould/order/create", this.saveFormData).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      update() {
        this.http.post("web/trial/mould/order/update", this.yt.editObj).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      delData(row) {
        //提示是否删除
        this.$confirm('是否确定删除', this.$t('tishi'), {
          confirmButtonText: this.$t('queding'),
          cancelButtonText: this.$t('quxiao'),
          type: 'error'
        }).then(() => {
          this.http.post("web/trial/mould/order/delete", row).then((res) => {
            this.utils.successMessage(this.$t('success'))
            this.yt.get(1)
          }).catch(error => {
            this.$message.error(this.$t(error));
          }).finally(() => {
            this.clear()
          })
        }).catch(() => {

        });
      },
      check(row){
        this.http.get("web/trial/mould/order/checkOrReject",{params:{id:row.id,operator:1}} ).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      reject(row){
        this.http.get("web/trial/mould/order/checkOrReject",{params:{id:row.id,operator:2}} ).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      issue(row){
        this.issuedFormData.trialMouldOrderId = this.yt.editObj.id
        this.http.post("web/trial/mould/order/issue", this.issuedFormData).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        }).finally(() => {
          this.clear()
        })
      },
      queryClear(orderBy) {
        this.conditions.begin = begin,
        this.conditions.end = end,
        this.conditions.status=null,
        this.conditions.mouldIds=[],
        this.conditions.materialIds=[],
        this.conditions.planNo=null,
        this.conditions.no=null,
          this.conditions.conclusion=null,
        this.yt.conditions = this.conditions,
        setTimeout(() => {
          this.yt.get(1)
        }, 300);
      },
      handleOpenConclusion(){
        setTimeout(() => {
          this.$set(this.yt.editObj,"conclusion","1")
        }, 300);
      },
      saveConclusion(){
        if(this.yt.editObj.conclusion === '0'){
          if(!this.yt.editObj.reason){
            this.utils.errorMessage(this.$t('shimobuhegeyuanyin') + this.$t('bitian'))
            return;
          }
          if(this.yt.editObj.imgInfoIds == null || this.yt.editObj.imgInfoIds.length == 0){
            this.utils.errorMessage(this.$t('meiyoutupian') )
            return;
          }
        }
        this.http.post("web/trial/mould/order/conclusion", this.yt.editObj).then((res) => {
          this.utils.successMessage(this.$t('success'))
          this.yt.isShowEditDialog = false
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(this.$t(error));
        })
        console.log()
      },
    },
    created() {
      setTimeout(() => {
        this.yt.conditions = this.conditions
        this.yt.get(1)
        this.$nextTick(() => {
          this.utils.event_hub.$emit('RESIZE')
        })
      }, 300);
    },
  }
</script>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/trial/mould/order/page" ref="yt" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shimozhuangtai')">
            <el-select v-model="yt.conditions.status" :placeholder="$t('shimozhuangtai')">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"></yi_time_input>
          </el-form-item>

          <el-form-item :label="$t('shimodanhao')">
            <el-input v-model="yt.conditions.no" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')">
            <yi_data_select multiple :type="'mould'" :ids.sync="yt.conditions.mouldIds" size="mini"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')">
            <yi_data_select multiple :type="'material2'" :ids.sync="yt.conditions.materialIds" size="mini"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shimojielun')">
            <yi_dictionary_select :max="1" :type="'TRIAL_MOULD_CONCLUSION'" :ids.sync="yt.conditions.conclusion">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="searchBtn()" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="queryClear(orderBy)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng',null,'w1')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '试模单-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status==='1'">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1"  v-if="utils.checkPower('web_mold_management_trial_mould_order_conclusion') && scope.row.status==='3' && (scope.row.conclusion == null ||scope.row.conclusion === '-1')">
            <el-button type="text" @click="yt.showEditDialog('jieluntianxie', scope.row,'w1',handleOpenConclusion())">
              {{ $t('jieluntianxie') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.conclusion ==='0' ||scope.row.conclusion === '1'">
            <el-button type="text" @click="yt.showEditDialog('jielunchakan', scope.row,'w1')">
              {{ $t('jielunchakan') }}
            </el-button>
          </el-col>

          <el-col :span="0.1" v-if="scope.row.status==='1'">
            <el-button type="text" @click="delData(scope.row)">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>

          <el-col :span="0.1" v-if="scope.row.status==='1'" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '试模单-审核' } }">
            <el-button type="text" @click="check(scope.row)">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>

          <el-col :span="0.1" v-if="scope.row.status==='2'" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '试模单-驳回' } }">
            <el-button type="text" @click="reject(scope.row)">
              {{ $t('bohui') }}
            </el-button>
          </el-col>

          <el-col :span="0.1" v-if="scope.row.status==='2'">
            <el-button type="text" @click="yt.showEditDialog('fafang', scope.row,'w1')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '试模单-发放' } }">
              {{ $t('fafang') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action==='xinzeng'">
        <el-form :model="saveFormData" label-width="auto" ref="ruleForm" size="mini">
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="saveFormData.mouldId" size="mini"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="saveFormData.materialId" size="mini"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shimoshuliang')">
            <el-input-number placeholder="请输入内容" v-model="saveFormData.trialMouldNum" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="saveFormData.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="clear()">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="create()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!--编辑-->
      <template v-if="yt.editObj.action==='bianji'">
        <el-form :model="yt.editObj" label-width="auto" ref="ruleForm" size="mini">
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId" size="mini"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_data_select :type="'material2'" :ids.sync="yt.editObj.materialId" size="mini"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shimoshuliang')">
            <el-input-number placeholder="请输入内容" v-model="yt.editObj.trialMouldNum" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="clear()">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="update()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action==='fafang'">
        <el-form :model="saveFormData" label-width="auto" ref="ruleForm" size="mini">
          <el-form-item :label="$t('jihuadanhao')" required>
            <el-input v-model="issuedFormData.planNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('guishuchejian')" required>
            <yi_data_select :max="1" :type="'organization'" :ids.sync="issuedFormData.orgId"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
            <yi_time_input type="datetimerange" :start.sync="issuedFormData.startTime" :end.sync="issuedFormData.endTime" :placeholder="$t('xuanzeriqiheshijian')"></yi_time_input>
          </el-form-item>

          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="issuedFormData.erpNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="issuedFormData.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="issue()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action==='jieluntianxie'">
        <el-form :model="yt.editObj" label-width="auto" ref="ruleForm" size="mini">
          <el-form-item :label="$t('shimojielun')" required prop="conclusion">
            <el-radio-group v-model="yt.editObj.conclusion" >
              <el-radio-button label="1" >{{ $t('hege') }}</el-radio-button>
              <el-radio-button label="0">{{ $t('buhege') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('shimobuhegeyuanyin')" v-if="yt.editObj.conclusion == '0'" required>
            <el-input type="textarea"  placeholder=" " v-model="yt.editObj.reason"  maxlength="200"></el-input>
          </el-form-item>
          <div  v-if="yt.editObj.conclusion == '0'">
            <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imgInfoIds" :limit="5">
              <div slot="limitMsg">
                  <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                    {{ $t('zuiduoshangchuan') }}
                  </span>
                <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                    <span>5</span>
                    <span style="color: #909399;font-size: 14px;font-weight: normal;">
                      {{ $t('zizhichitupian') }}
                    </span>
                  </span>
              </div>
            </yi_upload>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="yt.editObj.loading" size="mini" @click="saveConclusion()" type="primary"> {{ $t('baocun') }}  </el-button>
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action==='jielunchakan'">
        <el-form :model="yt.editObj" label-width="auto" ref="ruleForm" size="mini" :disabled="true">
          <el-form-item :label="$t('shimotianxieren')" >
            {{yt.editObj.conclusionNickname}}
          </el-form-item>
          <el-form-item :label="$t('shimotianxieshijian')" >
            {{dayjs(yt.editObj.conclusionTime).format( 'YYYY-MM-DD HH:mm:ss')}}
          </el-form-item>
          <el-form-item :label="$t('shimojielun')" >
            <span v-if="yt.editObj.conclusion == '1'">{{$t('hege')}}</span>
            <span v-if="yt.editObj.conclusion == '0'" style="color:red">{{$t('buhege')}}</span>
          </el-form-item>
          <el-form-item :label="$t('shimobuhegeyuanyin')" v-if="yt.editObj.conclusion == '0'">
            {{yt.editObj.reason}}
          </el-form-item>
          <div  v-if="yt.editObj.conclusion == '0'">
            <yi_upload style="margin-left: 20px;" :readOnly="true"  :ids.sync="yt.editObj.imgInfoIds" :limit="5">
            </yi_upload>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
